"use client";

import { TooltipContentProps } from "recharts";
import { scoreColor, TOOLTIP_SEPARATOR } from "./AnalysisOverview.logic";
import styles from "./AnalysisOverview.module.css";

export default function ScoreTooltip(props: TooltipContentProps) {
  const { active, payload, label } = props;
  const entry = payload?.[0];
  const value = Number(entry?.value);

  if (!active || !Number.isFinite(value)) {
    return null;
  }

  return (
    <div className={styles.tooltip}>
      <span className={styles.tooltipLabel}>
        {String(label)}
        {TOOLTIP_SEPARATOR}
      </span>
      <span className={styles.tooltipValue} style={{ color: scoreColor(value) }}>
        {value}
      </span>
    </div>
  );
}
